export default __webpack_public_path__ + "static/media/instagramIcon.45ba8966.svg";